import * as types from './mutation-types'
import utils from '@/utils';
import { loginApi, missionSquareApi } from '@/api/index.js';

const actions = {
    async [types.AUTHOR_CODE]({dispatch,commit}) {
        let authorInfo = await loginApi.authMe()
        window.localStorage.setItem('authorCode', authorInfo.permission);
        window.localStorage.setItem('userInfo', JSON.stringify({
            username: authorInfo.username,
            phone: authorInfo.phone,
            company: authorInfo.merchant ? authorInfo.merchant.company : '',
            agentName: authorInfo.agent_name ? authorInfo.agent_name : ''
        }))
        commit(types.USERINFO, JSON.stringify({
            id: authorInfo.id,
            username: authorInfo.username,
            phone: authorInfo.phone,
            is_forbidden: authorInfo.is_forbidden ? authorInfo.is_forbidden : '',
            agentName: authorInfo.agent_name ? authorInfo.agent_name : ''
        }));
        commit(types.AUTHOR_CODE, authorInfo.permission);

    },
    //任务详情
    async [types.TASKSINFODATA]({ dispatch, commit }, tasksId) {
        let data = await missionSquareApi.getTasksInfo(tasksId);
        commit(types.TASKSINFODATA, data);
    },
    //任务验收数量统计
    async [types.TASKSACCEPTANCESSTATISTICS]({ dispatch, commit }, task_no) {
        let data = await missionSquareApi.tasksAcceptancesStatistics(task_no);
        commit(types.TASKSACCEPTANCESSTATISTICS, data);
    },
    //任务验收列表
    async [types.TASKSACCEPTANCESLIST]({ dispatch, commit }, formData) {
        let data = await missionSquareApi.tasksAcceptances(formData.searchData, formData.task_no);
        commit(types.TASKSACCEPTANCESLIST, data.data);
        commit(types.TASKSACCEPTANCESDATA, data);
    },
    
}


export default actions;